// Copyright (c) 2025 Goffy. All Rights Reserved.

import { create } from 'zustand';

type RoundState = {
  roundId: string | null;
  hole: number | null;
  setRoundId: (roundId: string | null) => void;
  setHole: (hole: number | null) => void;
  setRoundAndHole: (roundId: string | null, hole: number | null) => void;
  clear: () => void;
};

export const useRoundState = create<RoundState>((set) => ({
  roundId: null,
  hole: null,
  setRoundId: (roundId) => set({ roundId }),
  setHole: (hole) => set({ hole }),
  setRoundAndHole: (roundId, hole) => set({ roundId, hole }),
  clear: () => set({ roundId: null, hole: null }),
}));
